import React from 'react';
import VictoryLoading from './components/VictoryLoading';
import createWebComponent from './react-web-component-wrapper';
import SelectCustomer from './components/SelectCustomer'
import FollowMe from './components/App'

createWebComponent(<FollowMe images={['p1', 'p2', 'p3', 'p1', 'p2', 'p3', 'p1', 'p2']} />, 'google-chart', false);